import { IApplicationState } from '../../../../../../types/types';
import { getAsidePanel } from './getAsidePanel';

export const getAsidePanelIsLeftPanelOpened = (
    state: IApplicationState
): boolean => {
    return getAsidePanel(state).leftPanelOpened;
};
